import { RouteInfo } from './../../_models/route-info.info';

export const ROUTES: RouteInfo[] = [
  {
    path: '/dashboard',
    title: 'Kontrolna tabla',
    icon: 'pi pi-align-justify',
    role: ['admin', 'sefProizvodnje', 'tehnolog'],
  },
  {
    path: '/nip',
    title: 'Nalozi IP',
    icon: 'pi pi-pencil',
    role: ['admin', 'prodavac', 'tehnolog', 'sefProizvodnje'],
  },
  {
    path: '/online-nip',
    title: 'Online nalozi',
    icon: 'pi pi-bookmark',
    role: ['admin', 'prodavac', 'tehnolog', 'sefProizvodnje'],
  },
  {
    path: '/operations',
    title: 'Operacije',
    icon: 'pi pi-file-o',
    role: ['admin', 'tehnolog'],
  },
  {
    path: '/products',
    title: 'Proizvodi',
    icon: 'pi pi-inbox',
    role: ['admin', 'tehnolog', 'prodavac'],
  },
  {
    path: '/users',
    title: 'Korisnici',
    icon: 'pi pi-user-plus',
    role: ['admin'],
  },
  {
    path: '/product_types',
    title: 'Tip proizvoda',
    icon: 'pi pi-sitemap',
    role: ['admin'],
  },
  {
    path: '/package_types',
    title: 'Tip pakovanja',
    icon: 'pi pi-table',
    role: ['admin', 'prodavac'],
  },
  {
    path: '/partners',
    title: 'Partneri',
    icon: 'pi pi-users',
    role: ['admin', 'prodavac'],
  },
  {
    path: '/status',
    title: 'Statusi',
    icon: 'pi pi-question-circle',
    role: ['admin'],
  },
  {
    path: '/employee-responsibilities',
    title: 'Zaduženja radnika',
    icon: 'pi pi-users',
    role: ['admin', 'sefProizvodnje'],
  },
  {
    path: '/nip-worker',
    title: 'Radni nalozi',
    icon: 'pi pi-clock',
    role: ['radnik', 'admin'],
  },
  {
    title: 'Izveštaji',
    icon: 'pi pi-copy',
    type: 'dropdown',
    opened: false,
    name: 'reports',

    children: [
      {
        path: '/daily-report',
        title: 'Dnevni izveštaj',
        icon: 'pi pi-copy',
        role: ['admin', 'sefProizvodnje', 'tehnolog'],
      },
      {
        path: '/periodic-report',
        title: 'Periodični izveštaj',
        icon: 'pi pi-copy',
        role: ['admin'],
      },
    ],
    role: ['admin', 'sefProizvodnje', 'tehnolog'],
  },
  {
    title: 'Analiza',
    icon: 'pi pi-chart-bar',
    type: 'dropdown',
    opened: false,
    name: 'global',

    children: [
      {
        path: '/product-report',
        title: 'Proizvod',
        icon: 'pi pi-copy',
        role: ['admin', 'sefProizvodnje', 'tehnolog'],
      },
      {
        path: '/delay-report',
        title: 'Zastoj',
        icon: 'pi pi-copy',
        role: ['admin'],
      },
      {
        path: '/worker-delay',
        title: 'Zastoj po operatoru',
        icon: 'pi pi-copy',
        role: ['admin'],
      },
      {
        path: '/scrap-report',
        title: 'Škart',
        icon: 'pi pi-copy',
        role: ['admin'],
      },
      {
        path: '/worker-report',
        title: 'Radnik',
        icon: 'pi pi-copy',
        role: ['admin'],
      },
    ],
    role: ['admin', 'sefProizvodnje', 'tehnolog'],
  },
  // {
  //   path: '/daily-report',
  //   title: 'Dnevni izveštaj',
  //   icon: 'pi pi-copy',
  //   role: ['admin', 'sefProizvodnje', 'tehnolog'],
  // },
  // {
  //   path: '/periodic-report',
  //   title: 'Periodični izveštaj',
  //   icon: 'pi pi-copy',
  //   role: ['admin'],
  // },
];
